export default __webpack_public_path__ + "static/media/footerfacebook.70d0f553.svg";